var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoverageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.4198 13.579C9.41084 12.57 9.56884 10.836 10.8948 10.055C11.5638 9.66102 12.4338 9.66102 13.1028 10.055C14.4278 10.836 14.5868 12.57 13.5778 13.579",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M13.576 13.579C12.704 14.451 11.29 14.451 10.418 13.579",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M5.16061 17.839C2.13661 14.302 2.29061 8.98201 5.63561 5.63601C9.15061 2.12101 14.8486 2.12101 18.3636 5.63601C21.7096 8.98201 21.8626 14.303 18.8386 17.839",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M7.65942 15.339C5.99842 13.182 6.13342 10.087 8.10942 8.111C10.2574 5.963 13.7394 5.963 15.8874 8.111C17.8644 10.088 17.9984 13.182 16.3364 15.339",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98828 20.013C8.50328 18.276 10.0933 17 11.9983 17C13.9033 17 15.4933 18.276 16.0083 20.013C13.4833 21.277 10.5133 21.276 7.98828 20.013Z",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageIcon);
export default __webpack_public_path__ + "static/media/coverage-icon.4ccda39255a2c0d01921ef77a83bf102.svg";
export { ForwardRef as ReactComponent };